<template>
  <div class="payment-layout min-h-screen bg-gradient-to-b from-green-50 via-white to-green-50" dir="rtl">
    <slot />
  </div>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    dir: 'rtl',
    lang: 'fa'
  }
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700;800;900&display=swap');

body {
  font-family: 'Vazirmatn', 'IRANSans', system-ui, sans-serif;
}
</style>
